import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import SvgInline from '@latitude/svg-inline';
import { Typography } from '../Typography';
import './_if_explainer.scss';
import { getCdrEntryBindingRichTextOptions } from '@/utils/contentfulRichTextBindings';

const InterestFreeCardList = props => {
  const { title, description, tiles } = props.data;
  const DESCRIPTION_OPTIONS = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.SUBTITLE>{children}</Typography.SUBTITLE>
      )
    }
  });

  const TITLE_OPTIONS = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.H3>{children}</Typography.H3>
      )
    }
  });

  const TAG_TEXT_OPTIONS = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.SUBTITLE>{children}</Typography.SUBTITLE>
      )
    }
  });

  const TILE_TITLE_OPTIONS = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.H3>{children}</Typography.H3>
      )
    }
  });

  const TILE_DESCRIPTION_OPTIONS = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.SUBTITLE>{children}</Typography.SUBTITLE>
      )
    }
  });

  const TILE_FOOTER_OPTIONS = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.BODY>{children}</Typography.BODY>
      )
    }
  });

  return (
    <div className="if-explainer">
      <div>
        {title && (
          <div className="if-explainer-title">
            {documentToReactComponents(title, TITLE_OPTIONS)}
          </div>
        )}
        {description && (
          <p className="if-explainer-description">
            {documentToReactComponents(description, DESCRIPTION_OPTIONS)}
          </p>
        )}
      </div>
      <div className="if-explainer-tiles-container">
        {tiles?.map(tile => (
          <div key={tile?.id} className="if-explainer-tile">
            <div
              className="if-explainer-tile-tag"
              css={`
                background-color: ${tile?.tagBg || 'unset'};
              `}
            >
              {tile?.tagIcon && (
                <SvgInline
                  className="if-explainer-tile-tag-icon"
                  name={tile?.tagIcon}
                />
              )}
              {tile?.tagText && (
                <p
                  className="if-explainer-tile-tag-text"
                  css={`
                    color: ${tile?.tagFontColor || 'unset'} !important;
                  `}
                >
                  {documentToReactComponents(tile?.tagText, TAG_TEXT_OPTIONS)}
                </p>
              )}
            </div>
            <div className="if-explainer-tile-content">
              {tile?.title && (
                <p className="if-explainer-tile-content-title">
                  {documentToReactComponents(tile?.title, TILE_TITLE_OPTIONS)}
                </p>
              )}
              {tile?.description && (
                <p className="if-explainer-tile-content-description">
                  {documentToReactComponents(
                    tile?.description,
                    TILE_DESCRIPTION_OPTIONS
                  )}
                </p>
              )}
            </div>

            {tile?.footer && (
              <div
                className="if-explainer-tile-footer"
                css={`
                  background-color: ${tile?.footerBg || 'unset'};
                `}
              >
                {documentToReactComponents(tile?.footer, TILE_FOOTER_OPTIONS)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InterestFreeCardList;
